/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'app/utils/loadable';

export const InsightsPage = lazyLoad(
  () => import('./index'),
  module => module.InsightsPage,
);
